  // @ts-ignore
import Litepicker from "./Litepicker.vue";

export default Litepicker;
